module.exports = __webpack_public_path__ + "img/tornoments.d1a59bce.jpg";